import { MONTHS_NAME } from "../config/params";

export const getFormattedReasons = (reasons: string) => {
  return reasons.split(",").join(", ");
};

export const getBookingMonth = (date: string, timeZone?: string)=>{
  const appointmentDate = new Date(+date * 1000);
  if (timeZone) {
    const formatter = new Intl.DateTimeFormat("en-US", {
      month: "long",
      timeZone,
    });

    return formatter.format(appointmentDate);
  }
  const monthName = MONTHS_NAME[appointmentDate.getUTCMonth()];

  return monthName;
};

export const formatReasonPetNames = (bookingPetsName: string[])=>{
  if (!Array.isArray(bookingPetsName) || bookingPetsName.length === 0) return "";

  if (bookingPetsName.length === 1) {
    return `${bookingPetsName[0]}`;
  } else if (bookingPetsName.length === 2) {
    return `${bookingPetsName[0]} and ${bookingPetsName[1]}`;
  } else if (bookingPetsName.length === 3) {
    return `${bookingPetsName[0]}, ${bookingPetsName[1]} and ${bookingPetsName[2]}`;
  }

  return "";
};
